import { Menu } from "antd";
import styled from "styled-components";
import { color } from "../../../resources";

export const MenuItem = styled(Menu.Item)`
    font-family: Anuphan-Regular;
    color: #303030 !important;
`

export const LinkItem = styled.span`
    z-index: 0
    font-size: 14px;
    font-family: ${(props: any) => props?.active ? 'Anuphan-Medium' : 'Anuphan-Regular'};
    color: ${(props: any) => props?.active ? color.main : '#303030'} !important;
`